module.exports = __webpack_public_path__ + "img/DS-J-16.c4982051.svg";